import React from "react";
import { useParams } from "react-router-dom";
import JobPageContainer from "../../containers/customer_portal/Job";

const JobDetailPage = () => {
  const { jobId } = useParams();
  return <JobPageContainer job_id={jobId} mode="detail" />;
};

export default JobDetailPage;